import { track } from '@minimal-analytics/ga4';

export const initAnalytics = () => {
  if (typeof window !== 'undefined') {
    track('G-W3XDZZBL9Z'); 
  }
};